import { ABTestsConfig } from '@play-co/replicant';

const tests = {
  TEST_PLACEBO_2: '0000_placebo_2',
  TEST_PLACEBO_3: '0000_placebo_3',
  TEST_PLACEBO_4: '0000_placebo_4',
  TEST_PLACEBO_5: '0000_placebo_5',
  TEST_DYNAMIC_AB_TEST: '0000_dynamic_ab_test',

  // TEST_FRIEND_REFERRAL: '0001_friend_referral',
  // TEST_INGAME_PROFILE: '0002_ingame_profile',
  // TEST_MATCH3_MINIGAME: '0003_match3_minigame',
  // TEST_AFFINITY_FRIENDS: '0004_affinity_friends',
  // TEST_TUTORIAL_BUTTONS: '0005_tutorial_buttons',
  // TEST_ENERGY_GIFT: '0006_energy_gift',
  // TEST_ENERGY_REFILL_TIME: '0007_energy_refill_time',
  // TEST_EVOLUTION_AND_DEATH: '0008_evolution_and_death',
  // TEST_VISIT_FRIENDS: '0009_visit_friends',
  // TEST_ENERGY_GIFT_POPUP: '0010_energy_gift_popup',
  // TEST_TUTORIAL_REWARD: '0011_tutorial_reward',
  // TEST_UNLOCK_FRIEND_INVITE: '0012_unlock_friend_invite',
  // TEST_INVITE_POPUP_LOW_BALANCE: '0013_invite_popup_low_balance',
  // TEST_INVITE_REWARD: '0014_invite_reward',
  // TEST_DUO: '0015_duo',
  // TEST_VISIT_FRIENDS_FIX: '0016_visit_friends_fix',
  // TEST_DEATH: '0017_death',
  // TEST_IMPROVE_IN_GAME_PROFILE_CVR: '0018_improve_in_game_profile_cvr',
  // TEST_FRIEND_SEARCH: '0019_friend-search',
  // TEST_CROSSPLAY_PROMOTION: '0020_crossplay_promotion',
  // TEST_SHOW_INVITE_POPUP_ON_GEMS_SHOP_OPEN:
  //   '0021_show_invite_popup_on_gems_shop_open',
  // TEST_SHOW_CROSSPLAY_ON_GEMS_SHOP_OPEN:
  //   '0022_show_crossplay_on_gems_shop_open',
  // TEST_SHOW_INVITE_POPUP_ON_RUN_OUT_OF_ENERGY:
  //   '0023_show_invite_popup_on_run_out_of_energy',
  // TEST_INVITE_MULTI_SELECT: '0024_invite_multi_select',
  // TEST_APP_INSTALL_NUDGE_POPUP_VARIANT: '0025_app_install_nudge_popup_variant',
  // TEST_IMPROVE_IN_GAME_PROFILE_CVR_V2: '0026_improve_in_game_profile_cvr_v2',
  // TEST_SHOW_APP_INSTALL_AT_LAUNCH: '0027_show_app_install_at_launch',
  // TEST_FAMILY_TREE: '0028_family_tree',
  // TEST_SETUP_IN_GAME_PROFILE: '0029_in_game_profile_setup',
  // TEST_SHOW_CROSS_PLAY_ON_LOW_GEMS_BALANCE:
  //   '0030_show_cross_play_on_low_gems_balance',
  // TEST_TWEAK_DEATH_RELATED_PARAMETERS: '0031_tweak_death_related_parameters',
  // TEST_POLISH_GEM_SHOP_UI: '0032_polish_gem_shop_ui',
  // TEST_TWEAK_DEATH_RELATED_PARAMETERS_V2: '0033_tweak_death_related_parameters',
  // TEST_NEW_CHARACTERS: '0034_new_characters',
  // TEST_INVITE_SUCCESS_REWARD: '0035_invite_success_reward ',
  // TEST_FRIEND_SEARCH_V2: '0036_friend_search_v2',
  // TEST_OPEN_SHOP_ON_OUT_OF_RESOURCES: '0037_open_shop_on_out_of_resources',
  // TEST_DECORATION: '0038_decoration',
  // TEST_MINIGAME_AFTER_RESULT: '0039_minigame_after_result',
  // TEST_CURRENCY_EXCHANGE_PROMPT: '0040_currency_exchange_prompt',
  // TEST_AUTO_DIALOG: '0041_auto_dialog',
  // TEST_REDUCE_ITEM_EFFECTS: '0042_reduce_care_item_effects_while_visiting',
  // TEST_INCREASE_ENERGY_TIMER: '0043_increase_energy_timer',
  // TEST_OPEN_ENERGY_SHOP_ON_OUT_OF_RESOURCES: '0044_open_energy_shop_on_out_of_resources',
  // TEST_MINIGAMES_VISIT: '0045_allow_minigames_while_visiting',
  // TEST_MINIGAMES_SLEEP: '0046_allow_minigames_while_sleeping',
  // TEST_AIRPLANE_MINIGAME: '0047_airplane_minigame',
  // TEST_AUTO_DIALOG_V2: '0048_auto_dialog_v2',
  // TEST_DAYCARE: '0049_daycare',
  // TEST_ATTRIBUTE_DECAY: '0050_attribute_decay',
  // TEST_FRIEND_VISIT_TARGET_LIST_IMPROVEMENT:
  //   '0051_friend_visit_target_list_improvement',
  // TEST_GIFT_STREAKS: '0052_gift_streaks',
  // TEST_MINIGAME_MULTIPLIER: '0053_minigame_multiplier',
  // TEST_LIMIT_IMPACT_FRIENDS_CARE: '0054_limit_impact_friends_care',
  // TEST_PROGRESSION: '0055_progression',
  // TEST_WALLPAPER_INVITE_REWARD: '0056_wallpaper_invite_reward',
  // TEST_REENGAGEMENT_OA: '0057_reengagement_oa',
  // TEST_GIFT_BPOINTS: '0058_gift_bpoints',
  // TEST_LIMIT_IMPACT_FRIENDS_CARE_V2: '0059_limit_impact_friends_care_v2',
  // TEST_PROGRESSION_V2: '0060_progression_v2',
  // TEST_MOCK_DUO: '0061_mock_duo',
  // TEST_GIFT_BPOINTS_V2: '0062_gift_bpoints_v2',
  // TEST_TWEAK_INITIAL_PETS: '0063_tweak_initial_pets',
  // TEST_OVERFILL_REMINDER: '0064_overfill_reminder',
  // TEST_TIME_BASED_PET_PROPERTIES: '0065_time_based_pet_properties',
  // TEST_WALLPAPER_REWARD_UNLOCK: '0066_wallpaper_reward_unlock',
  // TEST_WANT_OUT_MESSAGE: '0067_want_out_message',
  // TEST_LIMIT_IMPACT_FRIENDS_CARE_V3: '0068_limit_impact_friends_care_v3',
  // TEST_WALLPAPER_INVITE_REWARD_V3: '0069_wallpaper_invite_reward_v3',
  // TEST_RICH_MENU_DEEPLINK: '0070_richmenu_deeplink',
  // TEST_DECORATION_GACHA: '0071_decoration_gacha',
  // TEST_EVENTS: '0072_airplane_event',
  // TEST_FIX_0073: '0073_fix_0073_skipped_number',
  // TEST_TOILET_DECORATION: '0074_toilet_decoration',
  // TEST_TOILET_DECORATION_V2: '0075_toilet_decoration_v2',
  // TEST_PET_ACCESSORIES: '0076_pet_accessories',
  // TEST_EVENT_IMPROVEMENTS: '0077_airplane_event_improvements',
  // TEST_REDO_EVOLUTION: '0078_redo_evolution',
  // TEST_EVENTS_V2: '0079_events_v2',
  // TEST_IN_APP_ADS: '0080_in_app_ads',
  // TEST_REDO_EVOLUTION_V2: '0081_redo_evolution_v2',
  // TEST_GROWTH_ACCELERATION: '0082_growth_acceleration',
  // TEST_HINAMATSURI: '0083_hinamatsuri',
  // TEST_COLLECTION: '0084_collection',
  // TEST_LINE_IAP: '0085_line_iap',
  // TEST_SLOT_MACHINE: '0086_slot_machine',
  // TEST_PAYMENT_METHOD: '0087_payment_method',
  // TEST_RANDOM_BOX_GAME: '0088_random_box_game',
  // TEST_DECORATION_PROGRESSION: '0089_decoration_progression',
  // TEST_BUM_BUM_GAME: '0090_bum_bum_game',
  // TEST_RANDOM_BOX_GAME_V2: '0091_random_box_game_v2',
  // TEST_MATCH_2: '0092_match_2',
  // TEST_COLLECTION_V2: '0093_collection_v2',
  // TEST_PINATA_VS_SLOTS: '0094_pinata_vs_slots',
  // TEST_COLLECTION_V3: '0095_collection_v3',
  // TEST_PINATA_VS_SLOTS_V2: '0096_pinata_vs_slots_v2',
  // TEST_WEB_PAYMENT_PROCESSOR: '0097_web_payment_processor',
  // TEST_OA_REDUCTION: '0098_oa_reduction',
  // TEST_DECORATION_PROGRESSION_V2: '0099_decoration_progression_v2',
  // TEST_PURCHASE_RICH_MENU: '0100_purchase_rich_menu', // 100 tests, yay! :D
  // TEST_PUSH_NOTIFICATIONS: '0101_push_notifications',
  // TEST_UNIFIED_PINCH_SEQUENCE: '0102_unified_pinch_sequence',
  // TEST_UNIFIED_PINCH_SEQUENCE_V2: '0103_unified_pinch_sequence_v2',
  // TEST_PROGRESSION_MIGRATION: '0104_progression_migration',
  // TEST_REDUCE_GEMS_FROM_SLOTS: '0105_reduce_gems_from_slots',
  // TEST_GEMS_PINCH: '0106_gem_pinch_sequence_for_shop',
  // TEST_PUSH_NOTIFICATIONS_V2: '0107_push_notifications_v2',
  // TEST_OA_REDUCTION_HOLDOUT: '0108_oa_reduction_holdout',
  // TEST_AUTOCARE_IMPROVEMENTS: '0109_autocare_improvements',
  // TEST_FRENZY: '0110_frenzy',
  // TEST_FRIEND_INVITE_FOR_ENERGY_PINCH: '0111_friend_invite_for_energy_pinch',
  // TEST_IMPROVE_PN_PERMISSION: '0112_improve_pn_permission',
  // TEST_FRENZY_V2: '0113_frenzy_v2',
  // TEST_FRENZY_RTP: '0114_frenzy_rtp',
  // TEST_MATCH_2_V2: '0115_match_2_v2',
  // TEST_FRENZY_SCHEDULE: '0116_frenzy_schedule',
  // TEST_FRENZY_RTP_V2: '0117_frenzy_rtp_v2',
  // TEST_SPIN_SPEED: '0118_spin_speed',
  // TEST_UNLOCK_FRENZY_ON_SECOND_SESSION: '0119_unlock_frenzy_on_second_session',
  // TEST_BASE_PRICE: '0120_base_price',
  // TEST_FRENZY_MINIGAME_COMPETITION: '0121_frenzy_minigame_competition',
  // TEST_PET_COSTUME_PROGRESSION: '0122_pet_costume_progression',
  // TEST_FRENZY_MINIGAME_POINTS: '0123_improve_frenzy_point_per_spin',
  // TEST_MATCH_2_BASE: '0124_match_2_base',
  // TEST_BASE_PRICE_V2: '0125_base_price_v2',
  // TEST_MATCH2_LEVEL_PROGRESSION: '0126_match2_level_progression', Resolved to 'prog-block'
  // TEST_MATCH2_LEVEL_POPUP_AUTO_PROMPT: '0127_match2_level_popup_auto_prompt', Resolved to 'control'
  // TEST_MATCH2_FRENZY: '0128_match2_frenzy', Resolved to 'enabled'
  // TEST_MATCH2_PLAY_ON_NATIVE_POPUP: '0129_match2_play_on_native_popup', Resolved to 'all-native'
  // TEST_MINIGAME_SCORE_ADJUSTMENT: '0130_minigame_score_adjustment',
  // TEST_MATCH2_FRENZY_BALANCE: '0131_match2_frenzy_balance', Resolved to 'control'
  // TEST_MATCH2_RUBBERBANDING: '0132_match2_rubberbanding', Resolved to 'control'
  // TEST_PET_COSTUME_UI_IMPROVEMENTS: '0133_pet_costume_ui_improvements',
  // TEST_MATCH2_STAR_TOURNAMENT: '0134_match2_star_tournament',
  // TEST_PET_COSTUME_EARLY_GAME_IMPROVEMENTS:
  //   '0135_pet_costume_early_game_improvements', Resolved to 'control'
  // TEST_MATCH2_REDUCE_LEVEL_GEM_REWARD: '0136_match2_reduce_level_gem_reward',
  // TEST_MATCH2_DAILY_CHALLENGES: '0137_match2_daily_challenges', Replaced by v2
  // TEST_MATCH2_INCREASE_INVITES_GEM_REWARD:
  //   '0138_match2_increase_invites_gem_reward',
  // TEST_INCREASED_OA_FOR_SPENDERS: '0139_increased_oa_for_spenders',
  // TEST_MATCH2_STAR_SCORE: '0140_match2_star_score', Resolved to 'control'
  // TEST_ALT_FRIEND_INVITE: '0141_alternative_friend_invitation', // Superseded by v2
  // TEST_MATCH2_DAILY_REWARD_TEST: '0142_match2_daily_reward_test',
  // TEST_KOMOJU_PAYMENT_PROCESSOR: '0143_komoju_payment_processor',
  // TEST_MATCH2_DAILY_CHALLENGES: '0144_match2_daily_challenges_v2', Resolved to 'enabled'
  // TEST_MATCH2_RACE_V1: '0145_match2_race_v1', Resolved to 'enabled'
  // TEST_MATCH2_FRENZY_V3: '0146_match2_frenzy_v3',
  // TEST_KOMOJU_PAIDY: '0147_komoju_paidy',
  // TEST_KOMOJU_AUPAY: '0148_komoju_aupay',
  // TEST_MATCH2_NEW_TIMED_RACES_BOT: '0149_match2_new_timed_races_bots',
  // TEST_MATCH2_LOWERED_MOVE_COUNTS: '0150_match2_lowered_move_counts',
  // TEST_MATCH2_BLOCKGEN_ALGOS: '0151_match2_blockgen_algos',
  // TEST_MATCH2_ST_MATCHMAKING_V1: '0152_match2_tournaments_matchmaking_v1', Resolved to 'control'
  // TEST_MATCH2_SHOP_BUNDLES: '0153_match2_shop_bundles', // Resolved to 'enabled'
  // TEST_MATCH2_BLOCKGEN_ALGOS_V2: '0154_match2_blockgen_algos_v2',
  // TEST_MATCH2_BOTTOM_TOASTER: '0155_match2_bottom_toaster', // Resolved to 'control'
  // TEST_SEND_OA_INSTEAD_U2U_FOR_GIFTS: '0156_send_oa_instead_u2u_for_gifts',
  // TEST_MATCH2_DAILY_BONUS_REWARD_V3: '0157_match2_daily_bonus_reward_v3', // Resolved to 'enabled'
  // TEST_MATCH2_STAR_SCORE_V2: '0158_match2_star_score_v2', // Resolved to 'enabled'
  // TEST_MATCH2_BLOCKGEN_ALGOS_V3: '0159_match2_blockgen_algos_v3', // Resolved to 'control'
  // TEST_RACE_BOTS_V2: '0160_test_race_bots_v2', // Resolved to 'enabled'
  // TEST_MATCH2_RUBBERBANDING_V2: '0161_match2_rubberbanding_v2',
  // TEST_ALT_FRIEND_INVITE_V2: '0162_alternative_friend_invitation_v2', // Resolved to 'control' until LIFF migration
  // TEST_MATCH2_RUBBERBANDING_V2_RERUN: '0163_match2_rubberbanding_v2_rerun', // Resolved to 'level-inception'
  // TEST_STRIPE_GOOGLE_PAY: '0164_stripe_google_pay',
  // TEST_STRIPE_APPLE_PAY: '0165_stripe_apple_pay',
  // TEST_MATCH2_BUNDLE_SALE: '0166_match2_bundle_sale', // Resolved to 'free-first'
  // TEST_MATCH2_ST_MATCHMAKING_V2: '0167_match2_tournaments_matchmaking_v2', // Voided
  // TEST_MATCH2_PLAY_DIALOG: '0168_match2_play_dialog',
  // TEST_MATCH2_NEW_TOURNAMENT: '0169_match2_new_tournament',
  // TEST_MATCH2_NEW_BUTTON: '0170_match2_new_button', // Resolved to 'control'
  // TEST_MATCH2_NEW_TUTORIAL_FLOW: '0171_match2_new_tutorial_flow',  // Resolved to 'control'
  // TEST_MATCH2_FRENZY_BALANCE_V4: '0172_match2_frenzy_balance_v4', // Resolved to 'enabled'
  // TEST_MATCH2_RUBBERBANDING_UNLOCK: '0173_match2_rubberbanding_unlock',
  // TEST_MATCH2_ST_MATCHMAKING_V3: '0174_match2_tournaments_matchmaking_v3', // Resolved to 'enabled'
  // TEST_RAKUTEN_PAY: '0175_rakuten_pay',
  // TEST_MATCH2_MASTERS_LEAGUE: '0176_match2_masters_league', // Resolved to 'enabled'
  // TEST_GEM_PINCH_OPEN_NATIVE: '0177_gem_pinch_open_native',
  // TEST_MATCH2_MAGIC_LAMPS: '0178_match2_magic_lamps', // Resolved to 'enabled'
  // TEST_MATCH2_NEW_TOURNAMENT_RERUN: '0179_match2_new_tournament_rerun',
  // TEST_ALTERNATIVE_WEB_IAB: '0180_alternative_web_iab',
  // TEST_PURCHASE_OA_DESIGN: '0181_purchase_oa_design',
  // TEST_MATCH2_BATTLE_PASS: '0182_match2_battle_pass',
  // TEST_MATCH2_ST_MATCHMAKING_V4: '0183_match2_tournaments_matchmaking_v4',
  // FEATURE_MATCH2_MIGRATION_PET: 'match2_migration_pet',
  // FEATURE_MATCH2_MIGRATION_DECORATION: 'match2_migration_decoration',
  // FEATURE_MATCH2_MIGRATION_ACCESSORIES: 'match2_migration_accessories',
  // FEATURE_MATCH2_MIGRATION_DEFAULT: 'match2_migration_default',
  // TEST_MATCH2_INVITE_CELEBRATION: '0184_match2_invite_celebration',
  // TEST_MATCH2_NEW_LEVELS: '0185_match2_new_levels',
  // FEATURE_SPECIAL_MIGRATION_COMPENSATION: 'special_migration_compensation',
  // TEST_MATCH2_RUBBERBANDING_HOLDOUT: '0186_match2_rubberbanding_holdout', // Resolved to 'enabled'
  TEST_MATCH2_TEAMS: '0187_match2_teams',
  // TEST_WEB_IAB_PAYMENTS: '0188_alternative_web_iab_payments',
  // TEST_ALTERNATIVE_WEB_IAB: '0189_alternative_web_iab_v2',
  // TEST_MAGIC_LAMPS_TUNING: '0190_magic_lamps_tuning',
  // TEST_MATCH2_NEW_TOURNAMENT_V3: '0191_match2_new_tournament_v3',
  // FEATURE_MATCH2_DEFAULT_GAME: 'force_match2_as_default_game',
  // TEST_WEB_IAB_PAYMENTS: '0192_alternative_web_iab_payments_v2',
  // TEST_DISABLE_LINE_MESSAGE_BATCHING: '0193_disable_line_message_batching',
  // TEST_OUTSOURCING_LEVLES: '0194_outsourcing_levels',
  // TEST_RUBBERBANDING_V3: '0195_rubberbanding_v3',
  // TEST_LEVEL_TWEAKS: '0196_level_tweaks',
  // TEST_SOCIAL_CONTINUE: '0197_social_continue',
  // TEST_SOCIAL_CONTINUE: '0198_social_continue_v2', // resolved to 'enabled'
  // TEST_FIXED_LEVELS_HOLDOUT: '0199_fixed_levels_holdout', // Voided
  // TEST_CONTINUE_POPUP_VISUAL: '0200_continue_popup_visual', // Resolved to 'enabled'
  // TEST_FORCED_RESUBSCRIBE: '0201_forced_resubscribe',
  // TEST_LEVEL_27: '0202_level_27', // Voided
  // TEST_TUTORIAL_V2: '0203_tutorial_v2',
  // TEST_GIFTING_SEASON_EVENT: '0204_gifting_season_event',
  // TEST_RESURFACE_WALLPAPER: '0205_resurface_wallpaper',
  // TEST_LEVEL_27: '0206_level_27_v2',
  // TEST_REMOVE_FRIENDS: '0207_remove_friends',
  // TEST_TOURNAMENT_BOTS: '0208_tournament_bots',
  // TEST_TUTORIAL_V3: '0209_tutorial_v3',
  // TEST_PROGRESSIVE_SALE_EVENT: '0210_progressive_sale_event',
  // TEST_FORCED_RESUBSCRIBE: '0211_forced_resubscribe_v2',
  // TEST_FORCED_RESUBSCRIBE: '0212_forced_resubscribe_v3',
  // TEST_IMPROVED_TUTORIAL: '0213_tutorial_v4',
  // TEST_FORCE_PLAY_MATCH2: '0214_force_play_match2',
  // TEST_NEW_STREAK_EVENT: '0215_new_streak_event', // Voided
  // TEST_NEW_STREAK_EVENT: '0216_new_streak_event_v2',
  // TEST_RESURRECTION_EXPERIENCE: '0217_resurrection_experience',
  // TEST_RESURRECTION_FAST_FIRST_LEVEL: '0218_resurrection_fast_first_level',
  // TEST_RESURRECTION_OA: '0219_resurrection_oa',
  // TEST_TOURNAMENT_BOTS_V2: '0220_tournament_bots_v2',
  // TEST_HARDER_LEVELS: '0221_harder_levels',
  // TEST_AD_CONTINUE: '0222_ad_continue',
  // TEST_HARDER_LEVELS: '0223_harder_levels_v2',
  // TEST_LEVEL_29: '0224_level_29',
  // TEST_AD_CONTINUE: '0225_ad_continue_v2',
  // TEST_HANDLE_BROKEN_PUZZLES: '0226_handle_broken_puzzles',
  // TEST_HARDER_LEVELS_MOVES: '0227_harder_levels_moves',
  // TEST_FIX_228: '0228_FIX_228_SKIPPED_NUMBER',
  // TEST_STREAK_EVENT_V2: '0229_streak_event_v2',
  // TEST_PROGRESSIVE_SALE_EVENT: '0228_progressive_sale_event_v2',
  // TEST_AD_CONTINUE: '0230_ad_continue_v3',
  // TEST_MASTERS_LEAGUE_DIFFICULTY: '0231_masters_league_difficulty', // Resolved to 'control'
  // TEST_SALES_ON_CONTINUE: '0232_sales_on_continue',
  // TEST_NEW_VISUALS: '0233_new_visuals',
  // TEST_FRIENDS_MIGRATION_PHASE_ONE: '0234_friends_migration_phase_one',
  // TEST_FAKE_ENERGY_MESSAGE: '0235_fake_energy_message', // Resolved to 'control'
  // TEST_FRIENDS_MIGRATION_PHASE_ONE: '0236_friends_migration_phase_one',
  // TEST_SHRINE_QUEST: '0237_shrine_quest', // Resolved to control
  // TEST_VISIT_NOTIFICATION: '0238_visit_notification',
  // TEST_VISIT_NOTIFICATION: '0239_visit_notification_v2',
  // TEST_DAILY_BONUS_CHATBOT_MESSAGE: '0240_daily_bonus_chatbot_message',
  // TEST_AD_CONTINUE: '0241_ad_continue_v4', // It was 0231
  TEST_OPEN_WEB_PAYMENT: '0242_open_web_payment',
  // FEATURE_KOMOJU_AU: 'komoju_au',
  // FEATURE_KOMOJU_DOCOMO: 'komoju_docomo',
  // FEATURE_KOMOJU_SOFTBANK: 'komoju_softbank',
  // FEATURE_ATONE_PAYMENT_ENABLED: 'atone_payment_enabled',
  // FEATURE_KOMOJU_PAYPAY: 'komoju_paypay',
  // FEATURE_XSOLLA: 'xsolla',
  // TEST_REVISED_LEVELS: '0243_revised_levels', // Resolved to 'control'
  // TEST_RUBBERBANDING_V3: '0244_rubberbanding_v3', // Resolved to 'control'
  // TEST_COLLISION_SYSTEM_MODIFICATION: '0245_collision_system_modification',
  // TEST_BONUS_LEVEL: '0246_bonus_level',
  // TEST_GLOBAL_MASTERS_LEAGUE: '0247_masters_league_global',
  // TEST_REVISED_LEVELS_V2: '0248_revised_levels_v2',
  // TEST_OA_TO_ALL: '0249_oa_to_all',
  // TEST_REVISED_LEVELS_V3: '0250_revised_levels_v3', // Resolved to 'control'
  // TEST_OA_TO_ALL: '0251_oa_to_all_v2',
  // FEATURE_LIFF_MIGRATION: 'social_disabled',
  // TEST_GIFT_OA_BATCHING: '0252_gift_oa_batching',
  // TEST_FLASH_SALE_CONTINUE_BOOST: '0253_flash_sale_continue_boost',
  // TEST_CONVERSION_SALE_FORYOU: '0254_conversion_sale_for_you',
  // TEST_NATIVE_FLOW_FIX: '0255_native_purchase_flow_fix',
  // TEST_MAKE_HAPPY_BUTTON: '0256_make_happy_button', // Replaced by V2
  // TEST_AIRPLANE_EVENT: '0257_airplane_match2_event',
  // TEST_NEW_FIRST_150_LEVELS: '0258_new_first_150_levels',
  // TEST_INSTALL_RESUME_FLOW: '0259_install_resume_flow',
  // TEST_SPAWN_PET_OA: '0260_spawn_pet_oa',
  // TEST_TEEN_IMPROVEMENTS: '0261_teen_improvements', // Invalidated
  // TEST_TEEN_IMPROVEMENTS_V2: '0261_teen_improvements_v2',
  // TEST_OLD_FATE_LOGIC: '0262_old_fate_logic',
  // TEST_LIVEOPS_NOTIFICATIONS: '0263_liveops_notifications',
  //TEST_TEEN_IMPROVEMENTS_V3: '0264_teen_improvements_v3',
  // TEST_NEW_FIRST_150_LEVELS_V2: '0265_new_first_150_levels_v2',
  // TEST_NATIVE_PROMPT_POSITIONING: '0266_native_prompt_positioning',
  // TEST_NEW_VISUALS_HOLDOUT: '0267_new_visuals_holdout',
  // TEST_MAKE_HAPPY_BUTTON_V2: '0268_make_happy_button_v2',
  // TEST_OLD_FATE_LOGIC: '0269_old_fate_logic_v2',
  // TEST_ENGAGEMENT_SALE: '0270_engagement_sale',
  // TEST_TEEN_IMPROVEMENTS_V4: '0271_teen_improvements_v4',
  // TEST_PN_FAST_FOLLOW: '0272_pn_fast_follow',
  // TEST_NATIVE_INSTALL_DESIGN: '0273_native_install_design',
  // TEST_DISABLE_IN_GAME_FRIENDS: '0274_disable_in_game_friends',
  // TEST_STAR_SCORING: '0275_star_scoring',
  // TEST_NEW_SOUNDS: '0276_new_sounds',
  // TEST_LIVEOPS_NOTIFICATIONS: '0277_liveops_notifications_v2',
  // TEST_ENGAGEMENT_SALE: '0278_engagement_sale_v2',
  // TEST_NEW_FIRST_150_LEVELS_V3: '0279_new_first_150_levels_v3',
  // TEST_NATIVE_CONTINUE: '0280_native_continue',
  // TEST_VISIT_IMPROVEMENTS: '0281_visit_improvements',
  // TEST_NATIVE_HEAL: '0282_native_heal',
  // TEST_VISIT_IMPROVEMENTS_V2: '0283_visit_improvements_v2',
  // TEST_NATIVE_HEAL_V2: '0284_native_heal_v2',
  // FEATURE_KOMOJU_CHILD_WINDOW: 'komoju_child_window',
  // TEST_COOP_BUDDIES_EVENT: '0285_coop_buddies_event',
  // TEST_GACHA_EVENT: '0286_gacha_event',
  // TEST_POPUP_SEQUENCE: '0287_popup_sequence',
  // TEST_POPUP_SEQUENCE: '0288_popup_sequence_v2',
  // TEST_URL_INVITE: '0289_url_invite',
  // FEATURE_XSOLLA_DISABLED: 'xsolla_disabled', // temporary introducing a mean to disable xsolla for whitelisted users
  // TEST_CARDS_COLLECTION: '0290_cards_collection',
  // TEST_URL_INVITE: '0291_url_invite_v2',
  // TEST_EARLIER_FEATURE_UNLOCK: '0292_earlier_feature_unlock',
  // TEST_ALLOW_MINIGAME_WHILE_DEAD: '0293_allow_minigame_while_dead',
  // TEST_CURE_PET_ON_LOGIN: '0294_cure_pet_on_login',
  // TEST_FIX_295: '0295_FIX_295_SKIPPED_NUMBER',
  // TEST_TUTORIAL_HAND_ON_PET: '0296_tutorial_hand_on_pet',
  // TEST_FIX_297: '0297_FIX_297_SKIPPED_NUMBER',
  // TEST_CURE_PET_ON_LOGIN: '0298_cure_pet_on_login_v2',
  // TEST_NATIVE_EXP_FEATURE_SURFACING: '0299_native_exp_feature_surfacing',
  // TEST_AI_PET_CHATBOT: '0300_ai_pet_chatbot',
  // TEST_PURE_OPEN_WEB: '0301_pure_open_web_subtest',
  // TEST_REDUCED_INVITE_COOLDOWN: '0302_reduced_invite_cooldown',
  // TEST_INVITE_FRIENDS_SEARCH: '0303_invite_friends_search',
  // TEST_NEW_TUTORIAL: '0304_new_tutorial',
  // TEST_USE_REPLICANT_HEARTBEAT: '0305_use_replicant_heartbeat',
  // TEST_TIME_PRESSURE: '0306_time_pressure_invite',
  // TEST_LEAGUE_LEVEL_EXCLUSION: '0307_league_level_exclusion',
  // TEST_PURE_OPEN_WEB_V2: '0308_pure_open_web_v2',
  TEST_PURE_OPEN_WEB_V2: '0309_pure_open_web_v2',
  // TEST_BPOINTS_FROM_PUZZLE: '0310_bpoints_from_puzzle',
  // TEST_AI_PET_CHATBOT_INITIAL_CONVERSATION: '0311_ai_pet_chatbot_initial_conversation',
  // TEST_AI_PET_CHATBOT_INITIAL_CONVERSATION_V2:
  //   '0312_ai_pet_chatbot_initial_conversation_v2',
  // TEST_AI_PET_CHATBOT_INITIAL_CONVERSATION_V3:
  //   '0313_ai_pet_chatbot_initial_conversation_v3',
  // TEST_AI_PET_CHATBOT_QUIZ: '0314_ai_pet_chatbot_quiz',
  // TEST_ANIMATED_HOME_BUTTONS: '0315_animated_home_buttons',
  // TEST_DETERMINISTIC_BOT: '0316_deterministic_bot',
  // TEST_AI_PET_CHATBOT_GENERATED_QUIZ: '0317_ai_pet_chatbot_generated_quiz',
  // TEST_SPLASH_SCREEN: '0318_splash_screen',
  // TEST_GCINSTANT_ONPAUSE: '0319_gcinstant_onpause',
  // FEATURE_BPOINTS_FROM_PUZZLE: 'bpoints_from_puzzle',
  // TEST_SHOW_PLAY_ON_APP_EARLIER: '0320_show_play_on_app_earlier',
  // TEST_BPOINTS_FROM_PUZZLE_EXTENDED: '0321_bpoints_from_puzzle_extended',
  // TEST_MORE_BPOINTS_FROM_PUZZLE: '0322_more_bpoints_from_puzzle',
  // TEST_CHATBOT_INVITE: '0323_chatbot_invite',
  // TEST_OA_TO_ALL: '0324_oa_to_all_v3',
  // TEST_WEBP_LOADING: '0325_webp_loading',
  // TEST_DETERMINISTIC_BOT_RERUN: '0326_deterministic_bot_rerun',
  // TEST_DAILY_BONUS_CHANGES: '0327_daily_bonus_changes',
  // TEST_DETERMINISTIC_BOT_RERUN2: '0328_deterministic_bot_rerun',
  FEATURE_PURE_OPEN_WEB: 'pure_open_web',
  // TEST_FIXED_DEAD_PROBABILITY: '0329_fixed_dead_probability',
  // TEST_PURE_OPEN_WEB_EXPANDED: '0330_pure_open_web_expanded',
  TEST_DEMO_MODE: '0331_demo_mode',
  // TEST_OPEN_WEB_PURCHASE_MEMORY: '0332_open_web_purchase_memory',
  // TEST_DETERMINISTIC_SICK_FATE: '0333_deterministic_sick_fate',
  TEST_DETERMINISTIC_SICK_FATE: '0334_deterministic_sick_fate_rerun',
  // TEST_OPEN_WEB_PURCHASE_MEMORY: '0335_open_web_purchase_memory_rerun',
  // TEST_PURE_OPEN_WEB_EXPANDED: '0336_pure_open_web_expanded_rerun',
  FEATURE_OPEN_WEB_V2: 'pure_open_web_v2',
  // TEST_PET_STARTER_PACK: '0337_pet_starter_pack',
  // TEST_WEBPAY_STARTER_PACK_V2: '0338_webpay_starter_pack_v2',
  // TEST_WEB_CROSSPLAY: '0339_web_crossplay',
  // TEST_FULLSCREEN_SUPPORT: '0340_fullscreen_support',
  // TEST_ACCESS_DENIED_RETRY_LOGIN: '0341_access_denied_retry_login',
  // FEATURE_WHITELIST: 'feature_whitelist', // Removed in #11272 (devWhitelist cleanup)
  // TEST_DETERMINISTIC_TUTORIAL: '0342_deterministic_tutorial',
  // TEST_FAST_FOLLOW_LEVELS: '0343_fast_follow_levels',
  // TEST_FAST_FOLLOW_LEVELS_V2: '0344_fast_follow_levels_v2',
  // TEST_WEBPAY_STARTER_PACK_V3: '0345_webpay_starter_pack_v3',
  // TEST_CHATBOT_RETENTION_V2: '0346_chatbot_retention_v2',
  // TEST_WEB_SHARE_INVITE_V3: '0347_web_share_invite_v3',
  // TEST_REMOVE_PURPLE_FROM_FIRST_LEVEL: '0348_remove_purple_from_first_level',
  // TEST_WEB_SHARE_INVITE: '0349_web_share_invite_v4', // Removed in #10055
  // TEST_WEBPAY_HIGHLIGHT_PAYPAY: '0350_webpay_highlight_paypay',
  // TEST_TUTORIAL_REVAMP: '0351_tutorial_revamp_v1',
  // TEST_NEW_AFTER_PURCHASE_EXPERIENCE: '0352_new_after_purchase_experience'
  // TEST_WEBPAY_HIGHLIGHT_PAYPAY_V2: '0353_webpay_highlight_paypay_v2',
  // FEATURE_PUZZLE_FIXES: 'feature_puzzle_fixes_v2',
  // TEST_RACE_BOTS_OFFLINE_SCORE_FIX: '0354_race_bots_offline_score_fix',
  // TEST_MERPAY: '0355_merpay',
  // TEST_AUTO_CLOSE_CHILDWINDOW: '0356_auto_close_childwindow',
  // TEST_LEVEL_TUNING_CHURN: '0357_level_tuning_churn',
  // TEST_WEBPAY_OPTIMIZATION_V3: '0358_webpay_optimization_v3',
  // TEST_FUJI_REWARD_FIXES: '0359_fuji_reward_fixes',
  // TEST_AUTO_CLOSE_CHILDWINDOW_V2: '0360_auto_close_childwindow_v2',
  // TEST_MASTERS_LEAGUE_DIFFICULTY_V2: '0361_masters_league_difficulty_v2',
  // TEST_CONTINUE_POPUP_IMPROVEMENTS: '0362_continue_popup_improvements',
  // TEST_SHOP_SEGMENTATION_V1: '0363_shop_segmentation_v1',
  // FEATURE_CHILDWINDOW_CREDIT_CARD: 'feature_childwindow_credit_card',
  // TEST_SUPER_LOLLIPOP: '0364_super_lollipop',
  // TEST_FUJI_DELAY: '0365_fuji_delay',
  // TEST_TUTORIAL_REVAMP_PHASE_2: '0366_tutorial_revamp_phase_2',
  FEATURE_PURCHASE_HISTORY_RECONCILIATION:
    'feature_purchase_history_reconciliation',
  // TEST_MASTERS_LEAGUE_IMMORTAL_PETS: '0367_master_league_immortal_pets', // Resolved to 'control'
  // TEST_RUBBERBANDING_V4: '0368_rubberbanding_v4',
  // TEST_MASTERS_LEAGUE_RUBBERBANDING_V4: '0369_masters_league_rubberbanding_v4',
  // TEST_CHATBOT_RETENTION_V3: '0370_chatbot_retention_v3',
  // TEST_PLAY_BUTTON_NUDGE: '0371_play_button_nudge',
  // TEST_WEEKLY_LEADERBOARDS: '0372_weekly_leaderboards',
  // TEST_MOVE_REDUCTION: '0373_move_reduction',
  // TEST_BETTER_GUEST_MODE_LOGIN: '0374_better_guest_mode_login',
  // TEST_IAP_COMPONENT_MIGRATION: '0375_iap_component_migration',
  // TEST_TREASURE_EXPRESS: '0376_treasure_express',
  // TEST_RED_DOT_NOTIFICATION: '0377_red_dot_notification',
  // TEST_MOVE_REDUCTION_V2: '0378_move_reduction_v2',
  // TEST_CHAMPIONS_LEAGUE: '0379_champions_league',
  // TEST_SUPERLOLLIPOP_EASING_ACTIVATION: '0380_super_lollipop_easing_activation',
  // TEST_FIVE_MOVES_LEFT_WARNING: '0381_five_moves_left_warning',
  // TEST_MOVE_REDUCTION_V3: '0382_move_reduction_v3',
  // TEST_TREASURE_EXPRESS_CONFIGURATION: '0383_treasure_express_configuration',
  // TEST_PN_PERMISSION: '0384_pn_permission',
  FEATURE_ADS: 'feature_ads',
  // TEST_WEEKLY_LEADERBOARD_ADJUSTMENTS: '0385_weekly_leaderboard_adjustments',
  // TEST_RESCUE_QUEST: '0386_rescue_quest',
  // TEST_FAIRY_FOREST: '0387_fairy_forest',
  // TEST_FRENZY_NO_FREE_MOVES: '0388_frenzy_no_free_moves',
  // TEST_TREASURE_EXPRESS_VS_TURTLE_RACE: '0389_treasure_express_vs_turtle_race',
  // TEST_FUJI_SKIN_V2: '0390_fuji_skin_v2',
  // TEST_FUJI_REWARD_TUNING: '0391_fuji_reward_tuning',
  // TEST_PET_HAPPINESS_BOOSTER: '0392_pet_happiness_booster',
  // FEATURE_MINI_APP: 'feature_mini_app', // Removed: LIFF → MiniApp migration complete
  // TEST_FAIRY_FOREST_V2: '0393_fairy_forest_v2',
  TEST_FRENZY_NO_UNLIMITED_HAMMER: '0394_frenzy_no_unlimited_hammer',
  // TEST_FAIRY_FOREST_V3: '0395_fairy_forest_v3',
  // TEST_CHAMPIONS_LEAGUE_V2: '0396_champions_league_v2',
  // TEST_RUBBERBANDING_V5: '0397_rubberbanding_v5',
  // TEST_NEW_GUEST_NOTIFICATIONS: '0398_new_guest_notifications',
  // TEST_NEW_GUEST_SKIP_LOGIN: '0399_new_guest_skip_login',
  // TEST_FTUE_LOADING: '0400_ftue_loading',
  // TEST_NEW_30_LEVELS_FTUE: '0401_new_30_levels_ftue',
  // TEST_NEW_GUEST_NOTIFICATIONS_V2: '0402_new_guest_notifications_v2',
  // TEST_NEW_UI: '0403_new_ui',
  TEST_NEW_FIRST_2_OBSTACLE_VISUALS: '0404_new_first_2_obstacle_visuals',
  // TEST_BETTER_GUEST_MODE_LOGIN_V2: '0405_better_guest_mode_login_v2',
  // TEST_NEW_GUEST_NOTIFICATIONS_V3: '0406_new_guest_notifications_v3',
  // FEATURE_BETTER_PNS: 'feature_better_PNs',
  // TEST_HOME_SHORTCUT_INCENTIVE: '0407_home_shortcut_incentive', // Resolved to 'enabled'
  // TEST_SHARE_TARGET_PICKER: '0408_share_target_picker', // Resolved to 'enabled'
  // TEST_OA_FOR_UNSUBSCRIBED_PN: '0409_oa_for_unsubscribed_pn',
  // TEST_OA_FOR_UNSUBSCRIBED_PN_V2: '0410_oa_for_unsubscribed_pn_v2',
  // TEST_RESCUE_LEVELS: '0411_rescue_levels', // Removed: rescue levels are OA-only
  // TEST_RESCUE_LEVELS_RESURRECTION: '0412_rescue_levels_resurrection', // Removed: OA creative state activates rescue levels
  // TEST_MINI_APP_MIGRATION: '0413_mini_app_migration', // Removed: LIFF → MiniApp migration complete
  // FEATURE_DISABLE_LINE_IAP: 'feature_disable_line_iap',
  // FEATURE_SWITCHED_TO_MINI_APP_BY_NATIVE: 'feature_switched_to_mini_app_by_native', // Removed: LIFF → MiniApp migration complete
  // TEST_MINI_APP_MIGRATION_OA: '0414_mini_app_migration_oa',
  // TEST_MINI_APP_TOS_NUDGE: '0415_mini_app_tos_nudge',
  // TEST_PURCHASE_TOS_ACCEPTANCE_NUDGE: '0416_purchase_tos_acceptance_nudge',
  // TEST_ENABLE_NON_FRIEND_VISITS: '0417_enable_non_friend_visits',
  // TEST_INVITE_UI_IMPROVEMENT: '0418_invite_ui_improvement',
  FEATURE_NATIVE_CROSSPLAY_IOS: 'feature_native_crossplay_ios',
  FEATURE_NATIVE_CROSSPLAY_ANDROID: 'feature_native_crossplay_android',
  // TEST_FULL_OA: '0419_full_oa',
  // TEST_FULL_OA_FOR_EXISTING_TEENAGERS: '0420_full_oa_for_existing_teenagers',
  // TEST_FULL_OA_FOR_NON_NATIVE_USERS: '0421_full_oa_for_non_native_users',
  // TEST_FIREFLY_GARDEN: '0422_firefly_garden', // Feature removed in #11760
  // TEST_YAHOO_ADS: '0423_yahoo_ads',
  // TEST_DAILY_FORTUNE_SHARE: '0424_daily_fortune_share', // Resolved to 'control'
  // FEATURE_DAILY_FORTUNE: 'feature_daily_fortune', // Resolved to 'control'
  // TEST_DAYCARE_DURATION: '0425_daycare_duration', // Resolved to 'control'
  // TEST_BUTTON_NATIVE: '0426_button_native', // Resolved to 'enabled'
  // TEST_ADS_V2: '0427_ads_v2', // Resolved to 'enabled'
  // TEST_FIRST_LEVEL_IMPROVEMENTS: '0428_first_level_improvements', // Resolved to 'enabled'
  // TEST_ADD_FRIENDS_V2: '0429_add_friends_v2', // Superseded by 0430 due to issues in the first rollout
  // TEST_ADD_FRIENDS_V2_RERUN: '0430_add_friends_v2_rerun',
  // TEST_UPDATE_INVITE_UI: '0431_update_invite_ui', // Resolved to 'control'
  // TEST_STATUS_MESSAGE_RAMP: '0432_status_message_ramp', // Resolved to 'enabled'
  // TEST_IAP_TOS_DAILY_BONUS: '0433_iap_tos_daily_bonus', // Resolved to 'enabled'
  // TEST_INVITE_UI_V3: '0434_invite_ui_v3',
  // TEST_FRIEND_LIST: '0435_friend_list', // Resolved to 'enabled'
  // TEST_INVITE_UI_V4: '0436_invite_ui_v4', // Resolved to 'enabled'
  // TEST_FTUE_FORCE_RESUBSCRIBE: '0437_ftue_force_resubscribe', // Resolved to 'enabled'
  // FEATURE_PAUSE_PERFORMANCE_EVENT: 'feature_pause_performance_event', // Replaced by FEATURE_AMPLITUDE_EVENT_THROTTLE
  // TEST_REDUCE_DAILYBONUS_TOS_LEVEL: '0438_reduce_dailybonus_tos_level', // Resolved to 'enabled'
  // TEST_BAKING_BUDDIES: '0439_baking_buddies', // Replaced by 0445_baking_buddies_v2
  // FEATURE_BAKING_BUDDIES: 'feature_baking_buddies', // Resolved to 'enabled'
  // TEST_PET_WANTS_FRIEND: '0440_pet_wants_friend', // Resolved to 'enabled'
  // TEST_STATUS_MESSAGE_RAMP_EXISTING: '0441_status_message_ramp_existing_users', // Resolved to 'enabled'
  // TEST_IAP_TOS_DAILY_BONUS_V3: '0442_iap_tos_daily_bonus_v3', // Resolved to 'control'
  // TEST_INIT_COIN_GRANT: '0443_init_coin_grant', // Resolved to 'control'
  // TEST_PET_JANKEN: '0444_pet_janken', // Resolved to 'enabled'
  // FEATURE_PET_JANKEN: 'feature_janken', // Resolved to 'enabled'
  // TEST_BAKING_BUDDIES: '0445_baking_buddies_v2', // Resolved to 'enabled'
  // TEST_LIFF_REQUEST_FRIENDSHIP_API: '0446_liff_request_friendship_api',
  // TEST_LIFF_REQUEST_FRIENDSHIP_API_V2: '0447_liff_request_friendship_api_v2', // Bug: assigned too early in onLogin before GCinstant.isSubscribed resolved
  // TEST_HOME_LAYOUT_ADJUSTMENTS: '0448_home_layout_adjustments', // Resolved to 'control'
  // TEST_LIFF_REQUEST_FRIENDSHIP_API_V3: '0449_liff_request_friendship_api_v3', // Resolved to 'enabled'
  // TEST_INIT_COIN_GRANT_V2: '0450_init_coin_grant_v2', // Resolved to 'control'
  // TEST_IAP_TOS_PUZZLE_PINCH: '0451_iap_tos_puzzle_pinch', // Resolved to 'control'
  // TEST_FORCE_RESUBSCRIBE_ONLY: '0452_force_resubscribe_only', // Resolved to 'control'
  // TEST_VISIT_FLOW_OPTIMISATION: '0453_visit_flow_optimisation', // Resolved to 'enabled'
  // TEST_PIGGY_BANK: '0454_piggy_bank', // Resolved to 'control'
  // TEST_SOFT_RESUBSCRIBE_ONLY: '0455_soft_resubscribe_only', // Resolved to 'enabled'
  // TEST_IAP_TOS_PUZZLE_PINCH_V2: '0456_iap_tos_puzzle_pinch_v2', // Resolved to 'enabled'
  // TEST_ADS_V3: '0457_ads_v3', // Resolved to 'control'
  // TEST_FAKE_CATALOG_FLOW: '0458_fake_catalog_flow', // Superseded by TEST_OFFLINE_CATALOG_FLOW
  // TEST_DIRECT_LINE_RESUBSCRIBE: '0459_direct_line_resubscribe', // Resolved to 'enabled'
  // TEST_OFFLINE_CATALOG_FLOW: '0460_offline_catalog_flow', // Resolved to 'control'
  // TEST_RUBBERBANDING_V6: '0461_rubberbanding_v6', // Resolved to 'control'
  // TEST_LINE_RESUBSCRIBE_HINT_OVERLAY: '0462_line_resubscribe_hint_overlay', // Resolved to 'enabled'
  // TEST_BOOST_ROCKET_V1: '0463_boost_rocket', // Replaced by 0468_boost_rocket_v2
  FEATURE_AMPLITUDE_EVENT_THROTTLE: 'feature_amplitude_event_throttle',
  // TEST_YAHOO_ADS_PRELOAD_FIX: '0464_yahoo_ads_preload_fix', // Resolved to 'enabled'
  // TEST_GIFT_POPUP_SINGLE_CTA: '0465_gift_popup_single_cta', // Resolved to 'enabled'
  // TEST_ADS_V4: '0466_ads_v4', // Replaced by 0479_ads_v5
  // TEST_REMOVE_ANDROID_CROSSPLAY: '0467_remove_android_crossplay', // Resolved to 'control'
  // TEST_BOOST_ROCKET: '0468_boost_rocket_v2',
  // FEATURE_BOOST_ROCKET: 'feature_boost_rocket_v2',
  // TEST_PET_WANTS_FRIEND_V2: '0469_pet_wants_friend_v2', // Resolved to 'enabled'
  // TEST_FRIEND_LIST_SHARE_CTAS: '0470_friend_list_share_ctas', // Resolved to 'enabled'
  TEST_FLYING_HIGH_REDESIGN: '0471_flying_high_redesign',
  // TEST_SALLY_RESCUE_ONBOARDING: '0472_sally_rescue_onboarding', // Resolved to 'control'
  // TEST_SALLY_RESURRECTED_RESCUE_LANDING: '0473_sally_resurrected_rescue_landing', // Resolved to 'control'
  // TEST_CRATE_SKIPPER: '0474_crate_skipper_reengagement', // Resolved to 'control'
  // TEST_RUBBERBANDING_V7: '0475_rubberbanding_v7', // Resolved to 'control'
  // TEST_SC_ONBOARDING: '0476_sc_onboarding', // Resolved to 'control'
  // TEST_SC_INGAME_POPUP: '0477_sc_ingame_popup', // Resolved to 'add_friend_twice'
  // TEST_PET_DIALOG_ADD_FRIENDS_V3: '0478_pet_dialog_add_friends_v3', // Resolved to 'enabled'
  // TEST_ADS_V5: '0479_ads_v5', // Resolved to 'control'
  // TEST_SC_ONBOARDING_FOLLOWUP: '0480_sc_onboarding_followup', // Resolved to 'control'
  // FEATURE_VISIT_PRESENCE: 'feature_visit_presence', // Resolved to 'enabled'
  FEATURE_PURCHASE_FAILED_UI: 'feature_purchase_failed_ui',
  // TEST_FRIEND_LIST_CLUSTER: '0481_friend_list_cluster', // Resolved to 'enabled'
  // TEST_NEW_PET_DIALOGS: '0482_new_pet_dialogs', // Resolved to 'enabled'
  // TEST_MASTERS_LEAGUE_DIFFICULTY_PHASE_1: '0483_masters_league_difficulty_phase_1', // Resolved to 'enabled'
  // TEST_FIRST_50_LEVELS_DIFFICULTY: '0484_first_50_levels_difficulty', // Resolved to 'enabled'
  // TEST_ADS_V6: '0485_ads_v6', // Resolved to 'enabled'
  // TEST_CARDS_COLLECTION_V2: '0486_cards_collection_v2', // Resolved to 'enabled'
  // FEATURE_CARDS_COLLECTION_V2: 'feature_cards_collection_v2', // Resolved to 'enabled'
  // TEST_SUPPRESS_FEATURE_INTROS: '0487_suppress_feature_intros', // Restarted as 0493
  // TEST_MASTERS_LEAGUE_DIFFICULTY_PHASE_2: '0488_masters_league_difficulty_phase_2', // Resolved to 'enabled'
  FEATURE_ADS_ALLOW_LIST: 'feature_ads_allow_list',
  // TEST_INCENTIVIZED_OA_ADDITION: '0489_incentivized_oa_addition', // Resolved to 'enabled'
  // TEST_SPLASH_CREATIVE: '0490_splash_creative_test', // Resolved to 'control'
  // FEATURE_SPLASH_CREATIVE_MISMATCH: 'feature_splash_creative_test', // Removed with 0490
  // TEST_FTUE_LANDING_REVEAL: '0491_ftue_landing_reveal', // Resolved to 'control'
  // TEST_DREAM_DRIFT: '0492_dream_drift', // Resolved to 'control'
  TEST_SUPPRESS_FEATURE_INTROS_V2: '0493_suppress_feature_intros_v2',
  // TEST_INCENTIVIZED_OA_ADDITION_V2: '0494_incentivized_oa_addition_v2', // Resolved to 'control'
  // TEST_DREAM_DRIFT_TUNING: '0495_dream_drift_tuning', // Resolved to the twelve-node path
  TEST_COMPACT_RICH_MENU: '0496_compact_rich_menu',
  /** Same-level extra-move offers for players with no purchase history. */
  TEST_ESCALATING_EXTRA_MOVES: '0497_escalating_extra_moves',
  /** OA messages for subscribers who have never entered the game (#12269). */
  TEST_PRE_ENTRY_CHATBOT: '0498_pre_entry_chatbot',
} as const;

/**
 * GCinstant receiver ab test
 */
const receiverTests: ABTestID[] = [];

/**
 * GCinstant ab tests config
 */
const config = {
  [tests.TEST_PLACEBO_2]: createGCInstantTest('a', 'b'),

  [tests.TEST_PLACEBO_3]: createGCInstantTest('a', 'b', 'c'),

  [tests.TEST_PLACEBO_4]: createGCInstantTest('a', 'b', 'c', 'd'),
};

/**
 * Replicant dynamic ab tests config
 * Could be controlled from CStool
 */
export const dynamicAB = {
  [tests.TEST_DYNAMIC_AB_TEST]: createTest('control', 'enabled'),

  [tests.TEST_MATCH2_TEAMS]: createTest('control', 'enabled_teams'),

  [tests.TEST_OPEN_WEB_PAYMENT]: createTest('control', 'enabled_iab'),

  // [tests.TEST_LEAGUE_LEVEL_EXCLUSION]: createTest('control', 'enabled'),

  [tests.TEST_PURE_OPEN_WEB_V2]: {
    ...createTest('control', 'enabled_web'),
    assignManually: true,
  },

  [tests.FEATURE_PURE_OPEN_WEB]: {
    ...createFeatureFlag('enabled_web'),
    assignManually: true,
  },

  [tests.TEST_DEMO_MODE]: {
    ...createTest('control', 'afterFirstPuzzle', 'afterTutorial'),
    assignManually: true,
  },

  [tests.TEST_DETERMINISTIC_SICK_FATE]: createTest('control', 'enabled'),

  [tests.FEATURE_OPEN_WEB_V2]: {
    ...createFeatureFlag('enabled_web'),
    assignManually: true,
  },

  [tests.FEATURE_PURCHASE_HISTORY_RECONCILIATION]: createFeatureFlag('enabled'),

  [tests.FEATURE_ADS]: createFeatureFlag('enabled_ads'),

  [tests.TEST_FRENZY_NO_UNLIMITED_HAMMER]: createTest('control', 'enabled'),

  [tests.TEST_NEW_FIRST_2_OBSTACLE_VISUALS]: {
    ...createTest('control', 'enabled'),
    assignManually: true,
    newUsersOnly: true,
  },

  // Users with enabled crossplay feature flags should prioritize native app instead of mini app
  [tests.FEATURE_NATIVE_CROSSPLAY_IOS]: {
    ...createTest('enabled', 'disabled'),
    assignManually: true,
  },
  [tests.FEATURE_NATIVE_CROSSPLAY_ANDROID]: {
    ...createTest('enabled', 'disabled'),
    assignManually: true,
  },

  // Suppresses selected Amplitude analytics events when enabled.
  [tests.FEATURE_AMPLITUDE_EVENT_THROTTLE]: createFeatureFlag('enabled'),

  [tests.TEST_FLYING_HIGH_REDESIGN]: createTest('control', 'enabled'),

  // Purchase Failed UI rollout (#11474). Enabled players see the redesigned
  // failed/fatal popups; control players keep the legacy purchase failure UI.
  [tests.FEATURE_PURCHASE_FAILED_UI]: createFeatureFlag('enabled'),

  [tests.FEATURE_ADS_ALLOW_LIST]: {
    ...createFeatureFlag('enabled'),
    assignManually: true,
  },

  // Restart of 0487 with the new launch Friend Invite frequency (#12135).
  [tests.TEST_SUPPRESS_FEATURE_INTROS_V2]: createTest('control', 'enabled'),

  // Assigned from the OA subscribe webhook (#12205).
  [tests.TEST_COMPACT_RICH_MENU]: {
    ...createTest('control', 'enabled'),
    assignManually: true,
  },
  [tests.TEST_ESCALATING_EXTRA_MOVES]: createTest('control', 'enabled'),
  // Enrollment happens only on the first eligible OA follow, never on login.
  [tests.TEST_PRE_ENTRY_CHATBOT]: {
    ...createTest('control', 'enabled'),
    assignManually: true,
  },
} satisfies ABTestsConfig;

const contextConfig = {
  [tests.TEST_PLACEBO_5]: createTest('a', 'b', 'c', 'd', 'e'),
};

const assignableContextTests: ContextABTestID[] = [tests.TEST_PLACEBO_5];

export default {
  tests,
  contextConfig,
  assignableContextTests,
  config,
  receiverTests,
  dynamicAB,
};

export type ABTests = typeof config;
export type ABTestID = keyof ABTests;
export type ContextABTests = typeof contextConfig;
export type ContextABTestID = keyof ContextABTests;
export type ReceiverABTestID = (typeof receiverTests)[number];
export type ManuallyAssignedABTestID = {
  [K in ABTestID]: ABTests[K] extends { assignManually: boolean } ? K : never;
}[ABTestID];

export type ABTestBucket<T extends ABTestID> =
  ABTests[T]['buckets'][number]['id'];

export type ContextABTestBucket<T extends ContextABTestID> =
  ContextABTests[T]['buckets'][number]['id'];

export type RunningABTests = {
  [K in ABTestID]: ABTestBucket<K> | null | undefined;
};

//
// Helpers

function createGCInstantTest<
  A extends string,
  B extends string,
  T extends string[],
>(a: A, b: B, ...buckets: T) {
  return { active: true, default: a, ...createTest(a, b, ...buckets) };
}

function createTest<A extends string, B extends string, T extends string[]>(
  a: A,
  b: B,
  ...buckets: T
) {
  return {
    buckets: [a, b, ...buckets].map((bucket: A | B | T[number]) => ({
      id: bucket,
    })),
  };
}

function createFeatureFlag<A extends string>(a: A) {
  return {
    buckets: [a].map((bucket: A) => ({
      id: bucket,
    })),
  };
}

// Dynamic replicant ab tests helpers
export type DynamicABTests = typeof dynamicAB;
export type DynamicABTestID = keyof DynamicABTests;
export type DynamicABTestBucket<T extends DynamicABTestID> =
  DynamicABTests[T]['buckets'][number]['id'] & string;

export type DynamicABTestBucketID<
  TDynamicABTestID extends DynamicABTestID = DynamicABTestID,
> = DynamicABTestBucket<TDynamicABTestID>;
